/** Form block semanticId — registered via BUILD_PLAN_MANAGEMENT_FORM formBlock opts. */
export const PLAN_MANAGEMENT_FORM_SEMANTIC_ID = 'planManagementForm';

/** ComposeModal meta — clears termination-rules session store when plan modal closes. */
export const RESET_PLAN_TERMINATION_RULES_SESSION_ACTION_ID = 'RESET_PLAN_TERMINATION_RULES_SESSION';
